import React from "react";
import { Box, IconButton, Tooltip, Divider } from "@mui/material";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import styled from "@emotion/styled";

const ViewBox = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: theme.spacing(0, 2),
}));

const ListViewToggle = styled(IconButton)(({ theme }) => ({
    display: "none",
    [theme.breakpoints.up("md")]: {
        display: "flex",
    },
}));

const ViewToggle = ({ view, onChange }) => {
    return (
        <>
            <ViewBox>
                <Tooltip title="Card View">
                    <IconButton color={view === "card" ? "primary" : "default"} onClick={() => onChange("card")}>
                        <ViewModuleIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="List View">
                    <ListViewToggle color={view === "list" ? "primary" : "default"} onClick={() => onChange("list")}>
                        <ViewListIcon />
                    </ListViewToggle>
                </Tooltip>
            </ViewBox>
            <Divider />
        </>
    );
};

export default ViewToggle;
